var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        visible: _vm.innerVisible,
        title:
          _vm.pushLink === "17"
            ? _vm.$t("FileHistory.SendSetOfProxyOrders")
            : _vm.$t("FileHistory.SendDestinationPortAgent"),
        width: "750px",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "el-form",
        {
          staticStyle: { width: "fit-content", margin: "5px 0 0 40px" },
          attrs: { "label-width": "100px", "label-position": "left" }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("SeaExport.CompanyName") } },
            [
              _c("cargo-company-select", {
                staticStyle: { width: "100%" },
                attrs: {
                  "method-params": { designationAgent: true },
                  disabled: _vm.pushLink === "17",
                  "default-value": _vm.customerId || ""
                },
                on: { change: _vm.customerIdChange }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label:
                  _vm.$t("SeaExport.Receiver2") + _vm.$t("SeaExport.EmailGroup")
              }
            },
            [
              _c(
                "el-select",
                {
                  attrs: { filterable: "", multiple: "", clearable: "" },
                  on: { change: _vm.emailGroupToChange },
                  model: {
                    value: _vm.emailGroupTo,
                    callback: function($$v) {
                      _vm.emailGroupTo = $$v
                    },
                    expression: "emailGroupTo"
                  }
                },
                _vm._l(_vm.emailGroupToList, function(item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { label: item.groupName, value: item.uuid }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("SeaExport.Receiver2") } },
            [
              _c(
                "cargo-multiple-select",
                {
                  attrs: { filterable: "", "allow-create": "" },
                  on: { change: _vm.emailToChange },
                  model: {
                    value: _vm.emailToList,
                    callback: function($$v) {
                      _vm.emailToList = $$v
                    },
                    expression: "emailToList"
                  }
                },
                _vm._l(_vm.finalContactList, function(item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { label: item.name, value: item.uuid }
                  })
                }),
                1
              )
            ],
            1
          ),
          _vm.emailGroup
            ? _c(
                "el-form-item",
                {
                  attrs: {
                    label:
                      _vm.$t("SeaExport.Cc") + _vm.$t("SeaExport.EmailGroup")
                  }
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { filterable: "", multiple: "", clearable: "" },
                      on: {
                        change: _vm.emailGroupCcChange,
                        clear: _vm.onClearCc
                      },
                      model: {
                        value: _vm.emailGroupCc,
                        callback: function($$v) {
                          _vm.emailGroupCc = $$v
                        },
                        expression: "emailGroupCc"
                      }
                    },
                    _vm._l(_vm.emailGroupCcList, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.groupName, value: item.uuid }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("Partners.CcAddress") } },
            [
              _c("el-input", {
                attrs: { type: "textarea", rows: 3 },
                model: {
                  value: _vm.emailForm.cc,
                  callback: function($$v) {
                    _vm.$set(_vm.emailForm, "cc", $$v)
                  },
                  expression: "emailForm.cc"
                }
              })
            ],
            1
          ),
          _c("el-form-item", { attrs: { label: _vm.$t("queryJob.CCPost") } }, [
            _c(
              "div",
              { staticStyle: { margin: "5px 0" } },
              [
                _c(
                  "el-checkbox",
                  {
                    on: {
                      change: function($event) {
                        return _vm.ccChangeHandler("sales", _vm.sales)
                      }
                    },
                    model: {
                      value: _vm.sales,
                      callback: function($$v) {
                        _vm.sales = $$v
                      },
                      expression: "sales"
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.Sales")))]
                ),
                _c(
                  "el-checkbox",
                  {
                    on: {
                      change: function($event) {
                        return _vm.ccChangeHandler("op", _vm.op)
                      }
                    },
                    model: {
                      value: _vm.op,
                      callback: function($$v) {
                        _vm.op = $$v
                      },
                      expression: "op"
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.Operation")))]
                ),
                _c(
                  "el-checkbox",
                  {
                    on: {
                      change: function($event) {
                        return _vm.ccChangeHandler("csr", _vm.csr)
                      }
                    },
                    model: {
                      value: _vm.csr,
                      callback: function($$v) {
                        _vm.csr = $$v
                      },
                      expression: "csr"
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.CustomerService")))]
                ),
                _c(
                  "el-checkbox",
                  {
                    on: {
                      change: function($event) {
                        return _vm.ccChangeHandler("dc", _vm.doc)
                      }
                    },
                    model: {
                      value: _vm.doc,
                      callback: function($$v) {
                        _vm.doc = $$v
                      },
                      expression: "doc"
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.Documents")))]
                ),
                _c(
                  "el-checkbox",
                  {
                    on: {
                      change: function($event) {
                        return _vm.ccChangeHandler("emailGroup", _vm.emailGroup)
                      }
                    },
                    model: {
                      value: _vm.emailGroup,
                      callback: function($$v) {
                        _vm.emailGroup = $$v
                      },
                      expression: "emailGroup"
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.EmailGroup")))]
                ),
                _c(
                  "el-checkbox",
                  {
                    attrs: { no: "siteOP" },
                    on: {
                      change: function($event) {
                        return _vm.ccChangeHandler("siteOP", _vm.siteOP)
                      }
                    },
                    model: {
                      value: _vm.siteOP,
                      callback: function($$v) {
                        _vm.siteOP = $$v
                      },
                      expression: "siteOP"
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.FieldOperation")))]
                ),
                _c(
                  "el-checkbox",
                  {
                    attrs: { no: "overseaOp" },
                    on: {
                      change: function($event) {
                        return _vm.ccChangeHandler("overseaOp", _vm.overseaOp)
                      }
                    },
                    model: {
                      value: _vm.overseaOp,
                      callback: function($$v) {
                        _vm.overseaOp = $$v
                      },
                      expression: "overseaOp"
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.OverseaCustomerService")))]
                ),
                _c(
                  "el-checkbox",
                  {
                    attrs: { no: "planner" },
                    on: {
                      change: function($event) {
                        return _vm.ccChangeHandler("planner", _vm.planner)
                      }
                    },
                    model: {
                      value: _vm.planner,
                      callback: function($$v) {
                        _vm.planner = $$v
                      },
                      expression: "planner"
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.AirlinePerson2")))]
                ),
                _c(
                  "el-checkbox",
                  {
                    attrs: { no: "userDefinedRoleId1" },
                    on: {
                      change: function($event) {
                        return _vm.ccChangeHandler(
                          "userDefinedRoleId1",
                          _vm.userDefinedRoleId1
                        )
                      }
                    },
                    model: {
                      value: _vm.userDefinedRoleId1,
                      callback: function($$v) {
                        _vm.userDefinedRoleId1 = $$v
                      },
                      expression: "userDefinedRoleId1"
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_userDefinedRole1")))]
                ),
                _c(
                  "el-checkbox",
                  {
                    attrs: { no: "userDefinedRoleId2" },
                    on: {
                      change: function($event) {
                        return _vm.ccChangeHandler(
                          "userDefinedRoleId2",
                          _vm.userDefinedRoleId2
                        )
                      }
                    },
                    model: {
                      value: _vm.userDefinedRoleId2,
                      callback: function($$v) {
                        _vm.userDefinedRoleId2 = $$v
                      },
                      expression: "userDefinedRoleId2"
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_userDefinedRole2")))]
                ),
                _c(
                  "el-checkbox",
                  {
                    attrs: { no: "carbonSelf" },
                    on: { change: _vm.onCarbonSelfChange },
                    model: {
                      value: _vm.carbonSelf,
                      callback: function($$v) {
                        _vm.carbonSelf = $$v
                      },
                      expression: "carbonSelf"
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("queryJob.CCYourself")))]
                ),
                _c(
                  "el-checkbox",
                  {
                    model: {
                      value: _vm.defaultCc,
                      callback: function($$v) {
                        _vm.defaultCc = $$v
                      },
                      expression: "defaultCc"
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("queryJob.SaveCcAddresNextDefault")))]
                )
              ],
              1
            )
          ]),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("SeaExport.mailTemplate") } },
            [
              _c(
                "div",
                { staticStyle: { display: "flex" } },
                [
                  _c("el-checkbox", {
                    on: { change: _vm.emailTemplateCheck },
                    model: {
                      value: _vm.emailTemplate,
                      callback: function($$v) {
                        _vm.emailTemplate = $$v
                      },
                      expression: "emailTemplate"
                    }
                  }),
                  _c("cargo-combo-box", {
                    staticStyle: { flex: "1", "margin-left": "10px" },
                    attrs: {
                      disabled: !_vm.emailTemplate,
                      "allow-create": true,
                      clearable: true,
                      options: _vm.emailTemplateList,
                      "label-function": _vm.titleLabelFunction,
                      "placeholder-val": _vm.$t("SeaExport.placeholderVal"),
                      "value-field": "uuid",
                      "forbid-values": [""]
                    },
                    on: {
                      change: _vm.emailTemplateChange,
                      clear: _vm.onClearTitle
                    },
                    model: {
                      value: _vm.themeTemplate,
                      callback: function($$v) {
                        _vm.themeTemplate = $$v
                      },
                      expression: "themeTemplate"
                    }
                  })
                ],
                1
              )
            ]
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("SeaExport.emailSubject") } },
            [
              _c("el-input", {
                model: {
                  value: _vm.emailForm.title,
                  callback: function($$v) {
                    _vm.$set(_vm.emailForm, "title", $$v)
                  },
                  expression: "emailForm.title"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticStyle: { height: "300px" },
              attrs: { label: _vm.$t("SeaExport.MailContent") }
            },
            [
              _c("cargo-editor", {
                staticStyle: { width: "550px", height: "300px" },
                attrs: { "exclude-keys": _vm.excludeKeys },
                model: {
                  value: _vm.emailForm.mailContent,
                  callback: function($$v) {
                    _vm.$set(_vm.emailForm, "mailContent", $$v)
                  },
                  expression: "emailForm.mailContent"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("SeaExport.SendEMail") } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: _vm.$t("SeaExport.SystemEmail") },
                  model: {
                    value: _vm.emailForm.mailType,
                    callback: function($$v) {
                      _vm.$set(_vm.emailForm, "mailType", $$v)
                    },
                    expression: "emailForm.mailType"
                  }
                },
                _vm._l(_vm.sendEmailList, function(item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { label: item.name, value: item.id }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("Message.EmailAttachments") } },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "flex-direction": "column",
                    "min-height": "28px",
                    "padding-left": "10px",
                    border: "1px solid #EAEEF5",
                    "overflow-y": "auto",
                    height: "95px"
                  }
                },
                _vm._l(_vm.attachList, function(item, index) {
                  return _c(
                    "span",
                    { key: index },
                    [
                      _vm._v(" " + _vm._s(index + 1 + ". ") + " "),
                      [
                        "jpg",
                        "png",
                        "jpeg",
                        "gif",
                        "webp",
                        "pdf",
                        "doc",
                        "docx",
                        "xls",
                        "xlsx"
                      ].includes(_vm.getFileType(item.fileName))
                        ? _c(
                            "a",
                            {
                              staticStyle: {
                                "text-decoration": "underline",
                                "text-decoration-color": "blue"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.handlePreviewFile(
                                    item.fileId,
                                    item.fileName
                                  )
                                }
                              }
                            },
                            [_vm._v(" " + _vm._s(item.fileName) + " ")]
                          )
                        : [_vm._v(" " + _vm._s(item.fileName) + " ")],
                      _c("i", {
                        staticClass: "el-icon-close",
                        staticStyle: {
                          padding: "0 2px 0 5px",
                          "font-size": "14px",
                          color: "red",
                          "font-weight": "bold",
                          cursor: "pointer"
                        },
                        on: {
                          click: function($event) {
                            return _vm.removeAttach(item.fileId)
                          }
                        }
                      }),
                      _c("i", {
                        staticClass: "el-icon-download",
                        staticStyle: {
                          padding: "0 5px 0 3px",
                          "font-size": "14px",
                          color: "blue",
                          "font-weight": "bold",
                          cursor: "pointer"
                        },
                        on: {
                          click: function($event) {
                            return _vm.downloadFile(item.fileId)
                          }
                        }
                      })
                    ],
                    2
                  )
                }),
                0
              )
            ]
          ),
          _c(
            "div",
            {
              staticStyle: {
                "margin-top": "-70px",
                "padding-left": "-5px",
                "margin-bottom": "30px"
              }
            },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "fileUpload", type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.showCloudFile()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("FileHistory.Upload")))]
              ),
              _c("br"),
              _c(
                "el-button",
                {
                  staticStyle: { "margin-top": "5px" },
                  attrs: {
                    no: "packageDownload",
                    disabled: _vm.attachList.length === 0,
                    type: "primary"
                  },
                  on: { click: _vm.batchDownload }
                },
                [_vm._v(_vm._s(_vm.$t("queryJob.PackageDownload")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticStyle: { margin: "0 auto", width: "fit-content" },
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", plain: "" },
              on: { click: _vm.localEmailClickHandler }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.InvokeLocalMailClient")))]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.okClickHandler } },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Send")))]
          ),
          _c(
            "el-button",
            {
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
          )
        ],
        1
      ),
      _c("cargo-cloud-file-upload", {
        attrs: {
          visible: _vm.cloudFile.visible,
          job: _vm.cloudFile.job,
          "upload-source": _vm.uploadSource,
          lob: _vm.cloudFile.lob,
          "new-file": _vm.cloudFile.newFile
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.cloudFile, "visible", $event)
          },
          uploadDone: function(data) {
            _vm.uploadSuccess(data)
          }
        }
      }),
      _c("pre-view-file-dialog", {
        attrs: {
          "v-if": _vm.previewFileData.visible,
          title: _vm.$t("FileHistory.preview"),
          visible: _vm.previewFileData.visible,
          file: _vm.previewFileData.file,
          "can-maximize": true
        },
        on: { close: _vm.closePreviewDialog }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }